import { SELECT_BUDGET_TYPE, SELECT_BUDGET_CATEGORY } from '../actions/index';
import DataBudget from '../../data/data_budget.csv';
import DataPercentage from '../../data/data_percentage.csv';
import DataBudgetPerPersent from '../../data/data_budget_per_persent.csv';
import DataBudgetPerArea from '../../data/data_budget_per_area.csv';

const budgetData = {
  budget: DataBudget,
  percentage: DataPercentage,
  budgetPerPersent: DataBudgetPerPersent,
  budgetPerArea: DataBudgetPerArea,
};

const INITIAL_STATE = {
  category: 'social',
  categoryTitle: '福利服務支出',
  type: 'budget',
  data: DataBudget,
};

const budget = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_BUDGET_CATEGORY:
      return { ...state,
              category: action.budgetCategory,
              categoryTitle: action.categoryTitle };
    case SELECT_BUDGET_TYPE:
      return { ...state,
              type: action.budgetType,
              data: budgetData[action.budgetType] };
    default:
      return state;
  }
};

export default budget;



/** WEBPACK FOOTER **
 ** ./src/reducers/budget.js
 **/